import Swiper from 'swiper/bundle';
import AOS from 'aos/dist/aos';





jQuery(document).ready(function($){
 
    AOS.init({
        once: true,
        offset: 100,
        duration: 1200,
        easing: "ease"
    });


    var testimonials = new Swiper('.testimonials__slider', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      centeredSlides: true,
      navigation: {
        nextEl: '.testimonials__ctrl--next',
        prevEl: '.testimonials__ctrl--prev',
      },
      autoplay:{
        delay: 3000
      }
    });


  $('.burger').on('click', function(){
    $('body').toggleClass('show-menu');
    $('.overlay').fadeToggle();
  })

  $(window).scroll(function () {
    if ($(window).scrollTop() > 150 ) {
      $('.header').addClass('stick');
    }
    if ($(window).scrollTop() < 150) {
        $('.header').removeClass('stick');
    }
  });

 


  $('.faq__list h3').on('click', function(){
    var parent = $(this).parents('li');
    if( parent.hasClass('active')){
     parent.removeClass('active')
     parent.find('.faq__content ').slideUp();
    }else{
       parent.addClass('active').siblings().removeClass('active');
       parent.find('.faq__content ').slideDown();
       parent.siblings().find('.faq__content ').slideUp();
    } 
  })


  $('.forms__selector li').on('click', function(){
    var index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $('.forms__content .forms__panel').hide().eq(index).show();
  })

})